import { requestTemplate } from 'api';

interface ShareDocumentResponse {
  message: string;
  success: boolean;
  document_id: string;
}

const shareDocument = (
  payload: { document_token: string, addressees?: { email: string, user_name: string }[], mode: string, expires_option: string, expires_value: string, password?: string },
) => requestTemplate.post<ShareDocumentResponse>(`/temp_links/`, payload);

const incrementCounter = (temp_link_id: string) => requestTemplate.post(`/temp_links/view/?temp_link_id=${temp_link_id}`);

const getSharedLinks = (payload: {
  filters: { field: string; value: string }[];
  page?: number;
  per_page?: number;
  sort?: string;
}) => {
  const { filters, ...otherParams } = payload;
  const params = {
    ...otherParams,
    filters: JSON.stringify(filters),
  };
  return requestTemplate.get(`/temp_links/`, { params });
};

const revokeShare = (temp_link_id: string) =>
  requestTemplate.post(`/temp_links/revoke/`, { temp_link_id });

const share = {
  shareDocument,
  incrementCounter,
  revokeShare,
  getSharedLinks,
};

export default share;
